import jsPDF from "jspdf";

const toDataURLWithResize = (url, maxWidth = 200, maxHeight = 200) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // CORS

        img.onload = () => {
            let { width, height } = img;
            if (width > maxWidth || height > maxHeight) {
                const ratio = Math.min(maxWidth / width, maxHeight / height);
                width *= ratio;
                height *= ratio;
            }

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    if (!blob) {
                        reject(new Error("Erro ao converter canvas para blob"));
                        return;
                    }

                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                },
                "image/jpeg",
                0.7
            );
        };

        img.onerror = () => {
            reject(new Error("Erro ao carregar imagem"));
        };

        img.src = url;
    });
};

export const generateImagesPDF = async (produtos, sellersKits) => {
    // console.log('sellers kit inside: ', sellersKits)
    // console.log('produtos imgggg: ', produtos)
    const doc = new jsPDF({ unit: "mm", format: "a4" });

    const imagesPerRow = 3;
    const imageSize = 50;
    const padding = 10;

    let x = padding;
    let y = padding;
    let count = 0;

    for (const produto of produtos) {
        try {
            console.log('produto', produto)
            const base64 = await toDataURLWithResize(produto.imageUrl);
            doc.addImage(base64, "JPEG", x, y, imageSize, imageSize);
        } catch (err) {
            console.error(`Erro ao carregar imagem: ${produto.imageUrl}`, err);
            // Se erro, desenha o ID no lugar da imagem, texto preto centralizado
            doc.setFillColor(255, 255, 255); // fundo branco
            doc.rect(x, y, imageSize, imageSize, 'F'); // retângulo preenchido branco
            doc.setTextColor(0, 0, 0); // texto preto
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");

            // Centralizar texto no bloco da imagem:
            const text = produto.id;
            const textWidth = doc.getTextWidth(text);
            const textX = x + (imageSize - textWidth) / 2;
            const textY = y + imageSize / 2 + 6; // 6 ajusta verticalmente para o meio

            doc.text(text, textX, textY);
        }

        count++;
        if (count % imagesPerRow === 0) {
            x = padding;
            y += imageSize + padding;
        } else {
            x += imageSize + padding;
        }

        if (y + imageSize > doc.internal.pageSize.height) {
            doc.addPage();
            x = padding;
            y = padding;
        }
    }
    const formatName = sellersKits?.user?.nome + sellersKits?.user?.cpf
    doc.save(`galeria_${formatName}.pdf`);
};